<template>
    <div class="pt-8">
        <div class="flex gap-5">
            <div class="flex-none w-32 campaign-image rounded-md">
                <div :style="{'background-image': `url('${purchase.fullImageUrl}')`}"></div>
            </div>
            <div class="text-18 text-im-black-232323 font-bold w-full">
                {{purchase.name}}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SerialDetail",
    props: {
        purchase: Object,
    },
}
</script>
<style lang="scss" scoped>
    @import "../../../style/base/image.scss";
    .campaign-image {
        div {
            @include boxRatio(66.66%);
        }
    }
</style>
